module.exports = __webpack_public_path__ + "img/9.2d4df97f.jpg";